import React, { useEffect, useState } from "react";
import identificationCard from '../../images/identification-card.png';
import identificationIntroduction from '../../images/identification-introduction.png';
import { FoodNutritionLabel } from "./FoodNutritionLabel";
import JsonRequest from "../../components/jsonRequest";

export const FoodRecognitionComponent: React.FC<{ data?: any, imageUrl: string | null }> = ({
    data,
    imageUrl,
}) => {
    const [url, setImageUrl] = useState<string | null>(null);

    const getVisitUrl = async (url: string) => {
        const result = await JsonRequest.rawClient().get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json());
        return result?.data;
    };

    useEffect(() => {
        if (imageUrl) {
            getVisitUrl(imageUrl).then((url) => {
                setImageUrl(url);
            });
        }
    }, [imageUrl]);

    return (
        <>
            <div className="pulse-info">
                <div style={{
                    marginTop: 20,
                    position: 'relative',
                    textAlign: 'center',
                    backgroundImage: `url(${identificationCard})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '40px 20px 20px',
                }}>
                    {/* 图片展示区域 */}
                    {data?.generatePictureData?.qwenAnimationUrl && (
                        <div style={{ position: 'relative' }}>
                            <FoodNutritionLabel
                                imageUrl={url}
                                foodData={data?.recognitionData}
                            />
                        </div>
                    )}

                    {/* 文字介绍区域 */}
                    <div style={{
                        marginTop: 20,
                        position: 'relative',
                        textAlign: 'center',
                        backgroundImage: `url(${identificationIntroduction})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '15px',
                        margin: '10px 15px'
                    }}>
                        <div style={{
                            fontWeight: 600,
                            fontSize: '18px',
                            lineHeight: '25px',
                            color: '#94724B',
                            textAlign: 'center',
                            maxWidth: '100%',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                        }}>
                            {data?.summaryData?.summary?.emotional_summary}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};